import FormField from "./FormField";
import { cn, colors } from "tools/ui";
import { theme } from "theme/theme";

const style = "w-full py-2 px-2 text-right";
const PATTERN = /^-?\d*\.?\d{0,6}$/;
const formatter = Intl.NumberFormat("en-US");

/**
 *
 * @param {*} props -
    const _valueRef = `${mode
 * @param {Boolean} readOnly -
 * @param {String} type -
 * @param {String} label -
 * @param {String} name -
 * @param {String} placeholder -
 * @param {String} value -
 * @param {Function} onChange -
 * @param {Boolean} translate -
 * @returns Component TextField
 */
function Numeric(props) {
  const {
    name,
    data,
    label,
    readOnly,
    placeholder,
    onChange,
    field,
    icon,
    format,
    colSpan,
    decimalPlaces,
    model,
  } = props;

  const _style = style;

  let _color = "bg-white";
  if (readOnly) {
    _color = colors.readOnly;
  }

  function handleChange(event) {
    let _value = event.target.value;
    _value = _value.replaceAll(",", "");
    const validNumber = PATTERN.test(_value);

    if (!validNumber) {
      return;
    }
    data.value = _value;
  }

  function onBlur() {
    if (data?.value && typeof data.value === "string") {
      const _value = Math.round(parseFloat(data?.value.replace(/,/g, "")) || 0);
      data.value = Number(_value);
    }
    if (onChange) {
      onChange(name, data.value);
    }
  }

  let moreTools;
  if (format === "percent") {
    moreTools = <p className="pl-2 my-auto text-stone-700 text-sm">%</p>;
  }
  if (field.symbol) {
    moreTools = (
      <p className="pl-2 my-auto text-stone-700 text-sm">{field.symbol}</p>
    );
  }

  return (
    <FormField
      label={label}
      name={name}
      required={field.required}
      colspan={colSpan}
      model={model}
    >
      <input
        key={name}
        id={name}
        name={name}
        className={cn(
          _color,
          _style,
          theme.textColor,
          theme.border,
          theme.input.height,
          theme.input.text,
        )}
        type="text"
        value={formatter.format(Math.round(Number(data.value) || 0))}
        onChange={handleChange}
        onBlur={onBlur}
        disabled={readOnly ?? false}
        placeholder={placeholder ?? ""}
      />
      {icon || null}
    </FormField>
  );
}

export default Numeric;
